// extracted by mini-css-extract-plugin
export default {"blured-background":"styles-module__blured-background___WAQZc","slugs-list":"styles-module__slugs-list___CmHBT","loading":"styles-module__loading___IMsyN"};